// Module
var code = "<!DOCTYPE html> <html> <head> <title>Hello Pug</title> </head> <body> <div id=\"pdfViewer\"></div> </body> </html> ";
// Exports
export default code;